import PropTypes from 'prop-types';

import { Box, Button, Spinner } from '@zillow/constellation-10';

const propTypes = {
  pager: PropTypes.object,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  onLoadMoreClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

const defaultProps = {
  pager: {
    startKey: 0,
    endKey: 0,
    hasMore: false,
  },
  text: 'Load more',
  disabled: false,
  isLoading: false,
};

const InfiniteScroller = ({ pager, text, disabled, onLoadMoreClick, isLoading }) => {
  const { hasMore } = pager;

  const handleLoadMoreClick = () => {
    const { endKey } = pager;
    onLoadMoreClick(endKey);
  };

  return (
    <div>
      {hasMore && (
        <Box css={{ display: 'flex', justifyContent: 'center' }}>
          {isLoading ? (
            <Spinner size="md" />
          ) : (
            <Button
              tone="brand"
              emphasis="filled"
              onClick={disabled ? null : handleLoadMoreClick}
              disabled={disabled}
              css={{ marginBlock: '200' }}
            >
              {text}
            </Button>
          )}
        </Box>
      )}
    </div>
  );
};

InfiniteScroller.propTypes = propTypes;
InfiniteScroller.defaultProps = defaultProps;

export default InfiniteScroller;
